import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import {useState} from "react";
import {Navigate} from "react-router-dom";
import Editor from "../Editor";
import Category from "./category";

export default function CreatePost() {
  const [title,setTitle] = useState('');
  const [category,setCategory] = useState('');
  const [summary,setSummary] = useState('');
  const [content,setContent] = useState('');
  const [files, setFiles] = useState('');
  const [password, setPassword] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [categoryName,setCategoryName] = useState('');

  async function createNewPost(ev) {
    const data = new FormData();
    data.set('title', title);
    data.set('summary', summary);
    data.set('content', content);
    data.set('file', files[0]);
    data.set('category', category);
    ev.preventDefault();
    if(password == 'minggatuAdmin789$') {
    const response = await fetch('https://minggatu.zyberapi.site/post', {
      method: 'POST',
      body: data,
      credentials: 'include',
    });
    if (response.ok) {
      setRedirect(true);
    } 
    } else {
      alert('pass inccorrect');
    }
  }

  if (redirect) {
    return <Navigate to={'/'} />
  }
  return (
    <div>
      <Category/>
      <form onSubmit={createNewPost}>
        <input type="title"
               placeholder={'Title'}
               value={title}
               onChange={ev => setTitle(ev.target.value)} />
        <input type="category"
               placeholder={'Category'}
               value={category}
               onChange={ev => setCategory(ev.target.value)} />
        <input type="password"
               placeholder={'Password'}
               value={password}
               onChange={ev => setPassword(ev.target.value)} />
        <input type="summary"
               placeholder={'Summary'}
               value={summary}
               onChange={ev => setSummary(ev.target.value)} />
        <input type="file"
               onChange={ev => setFiles(ev.target.files)} />
        <Editor value={content} onChange={setContent} />
        <button style={{marginTop:'5px'}}>Create post</button>
      </form>
    </div>
  );
}